import _defineProperty from '../../../node_modules/@babel/runtime/helpers/esm/defineProperty.js';
import React__default from 'react';
import PropTypes__default from 'prop-types';
import clsx from 'clsx';
import { makeStyles, useTheme, Card, CardContent, Grid, Typography, List, ListItem, Box, ListItemText, Paper } from '@material-ui/core';
import { retrieveContentfulImage } from '../../common/image.js';
import { LazyLoadImage } from 'react-lazy-load-image-component';

var useStyles = makeStyles(function (theme) {
  return {
    card: _defineProperty({
      width: theme.spacing(46),
      display: "flex",
      flexDirection: "column",
      height: "100%",
      borderStyle: "none"
    }, theme.breakpoints.down("xs"), {
      width: theme.spacing(43)
    }),
    media: {
      height: theme.spacing(18.75),
      objectFit: "cover"
    },
    height100: {
      height: "100%"
    },
    content: {
      background: "#406943",
      paddingLeft: theme.spacing(2),
      paddingTop: theme.spacing(2),
      paddingBottom: theme.spacing(1) + "px !important",
      height: "100%"
    },
    name: {
      color: theme.palette.text.white,
      paddinBottom: theme.spacing(0.5)
    },
    memberSince: {
      color: theme.palette.text.white
    },
    exampleFor: {
      color: theme.palette.text.white,
      textDecoration: "underline",
      paddingTop: theme.spacing(2),
      paddingBottom: theme.spacing(1)
    },
    avatar: {
      width: theme.spacing(4),
      height: theme.spacing(4)
    },
    journeyList: {
      width: "100%"
    },
    journeyItem: {
      width: "100%",
      padding: 0,
      margin: theme.spacing(0, 0, 1, 0)
    },
    journeyText: {
      color: theme.palette.text.white
    },
    numOfShares: {
      marginTop: "auto",
      background: "#406943",
      height: theme.spacing(5)
    },
    rect: {
      width: theme.spacing(2),
      height: theme.spacing(3),
      marginRight: "5px",
      transform: "matrix(0.99, 0.24, -0.16, 0.97, 0, 0)",
      background: theme.palette.text.white
    },
    sharesText: _defineProperty({
      marginRight: theme.spacing(1.5)
    }, theme.breakpoints.down("xs"), {
      marginRight: theme.spacing(1.5)
    }),
    sharesTextColor: {
      color: theme.palette.text.white
    }
  };
});
var ShareholderCard = function ShareholderCard(_ref) {
  var imageTitle = _ref.imageTitle,
    imageUrl = _ref.imageUrl,
    name = _ref.name,
    memberSince = _ref.memberSince,
    exampleFor = _ref.exampleFor,
    journeys = _ref.journeys,
    numberOfShares = _ref.numberOfShares,
    labelShare = _ref.labelShare,
    labelShares = _ref.labelShares;
  var classes = useStyles();
  var theme = useTheme();
  return /*#__PURE__*/React__default.createElement(Card, {
    className: classes.card,
    elevation: 0
  }, /*#__PURE__*/React__default.createElement(LazyLoadImage, {
    src: retrieveContentfulImage(imageUrl, {
      width: 640,
      height: 430
    }),
    className: classes.media,
    alt: imageTitle || ""
  }), /*#__PURE__*/React__default.createElement(CardContent, {
    className: classes.content
  }, /*#__PURE__*/React__default.createElement(Grid, {
    className: classes.height100,
    container: true,
    direction: "column",
    justify: "flex-start"
  }, /*#__PURE__*/React__default.createElement(Grid, {
    item: true,
    container: true,
    direction: "column"
  }, /*#__PURE__*/React__default.createElement(Grid, {
    item: true
  }, /*#__PURE__*/React__default.createElement(Typography, {
    variant: "h5",
    className: classes.name
  }, name)), /*#__PURE__*/React__default.createElement(Grid, {
    item: true
  }, /*#__PURE__*/React__default.createElement(Typography, {
    variant: "body2",
    className: classes.memberSince
  }, memberSince)), /*#__PURE__*/React__default.createElement(Grid, {
    item: true
  }, /*#__PURE__*/React__default.createElement(Typography, {
    variant: "body2",
    className: classes.exampleFor
  }, exampleFor))), /*#__PURE__*/React__default.createElement(Grid, {
    item: true
  }, /*#__PURE__*/React__default.createElement(List, {
    className: classes.journeyList,
    component: "div",
    disablePadding: true
  }, journeys === null || journeys === void 0 ? void 0 : journeys.map(function (journey, index) {
    return /*#__PURE__*/React__default.createElement(ListItem, {
      className: classes.journeyItem,
      component: "div",
      key: index
    }, /*#__PURE__*/React__default.createElement(Box, {
      display: "flex",
      marginRight: 2,
      width: theme.spacing(5),
      height: theme.spacing(5),
      border: "".concat(theme.spacing(0.1), "px solid white"),
      borderRadius: 8,
      justifyContent: "center",
      alignItems: "center"
    }, /*#__PURE__*/React__default.createElement(LazyLoadImage, {
      className: classes.avatar,
      src: journey === null || journey === void 0 ? void 0 : journey.iconUrl,
      alt: journey.iconTitle || ""
    })), /*#__PURE__*/React__default.createElement(ListItemText, {
      primary: journey === null || journey === void 0 ? void 0 : journey.title,
      primaryTypographyProps: {
        variant: "subtitle1",
        className: classes.journeyText
      },
      secondary: journey === null || journey === void 0 ? void 0 : journey.subtitle,
      secondaryTypographyProps: {
        className: clsx(classes.journeyText, classes.memberSince)
      }
    }));
  }))), /*#__PURE__*/React__default.createElement(Grid, {
    className: classes.numOfShares,
    item: true,
    container: true,
    direction: "row",
    alignItems: "center",
    justify: "flex-end",
    spacing: 0
  }, numberOfShares > 0 && Array.from(new Array(numberOfShares)).map(function (_, index) {
    return /*#__PURE__*/React__default.createElement(Grid, {
      key: index,
      item: true
    }, /*#__PURE__*/React__default.createElement(Paper, {
      className: classes.rect,
      square: true
    }));
  }), /*#__PURE__*/React__default.createElement(Grid, {
    item: true,
    className: classes.sharesText
  }, /*#__PURE__*/React__default.createElement(Typography, {
    variant: "body1",
    className: classes.sharesTextColor
  }, "".concat(numberOfShares === null ? 0 : numberOfShares, " "), numberOfShares > 1 || !numberOfShares ? (labelShares === null || labelShares === void 0 ? void 0 : labelShares.charAt(0).toUpperCase()) + (labelShares === null || labelShares === void 0 ? void 0 : labelShares.slice(1)) : (labelShare === null || labelShare === void 0 ? void 0 : labelShare.charAt(0).toUpperCase()) + (labelShare === null || labelShare === void 0 ? void 0 : labelShare.slice(1))))))));
};
ShareholderCard.propTypes = {
  imageTitle: PropTypes__default.string,
  imageUrl: PropTypes__default.string,
  name: PropTypes__default.string,
  memberSince: PropTypes__default.string,
  exampleFor: PropTypes__default.string,
  journeys: PropTypes__default.array,
  numberOfShares: PropTypes__default.number,
  labelShare: PropTypes__default.string,
  labelShares: PropTypes__default.string
};

export { ShareholderCard as default };
//# sourceMappingURL=ShareholderCard.js.map
